import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const UpdateGlyph = /*#__PURE__*/createElement("g", {
  id: "update"
}, /*#__PURE__*/createElement("path", {
  d: "M61.1,68.5c-0.8,0-1.6-0.4-2.1-1L43.7,47.1c-0.6-0.8-0.7-1.8-0.3-2.7c0.4-0.9,1.3-1.4,2.3-1.4H53 c-0.5-19.4-11.2-24.4-11.6-24.6c-0.6-0.3-1-1-0.8-1.7c0.1-0.7,0.7-1.2,1.4-1.2c15.7,0,25.2,10,26.4,27.4h8.1c1,0,1.9,0.6,2.3,1.4 s0.3,1.9-0.3,2.7L63.2,67.5C62.7,68.1,62,68.5,61.1,68.5z M46.5,45.9l14.7,19.5l14.7-19.5H67c-0.8,0-1.4-0.6-1.5-1.4 c-0.4-8.8-3.3-23-18.4-25.6C51,22.6,56,30.2,56,44.4c0,0.8-0.7,1.5-1.5,1.5H46.5z"
}), /*#__PURE__*/createElement("path", {
  d: "M42,68.5c-15.7,0-25.2-10-26.4-27.4H7.5c-1,0-1.9-0.6-2.3-1.4c-0.4-0.9-0.3-1.9,0.3-2.7l15.3-20.4c0.5-0.7,1.3-1,2.1-1 c0,0,0,0,0,0c0.8,0,1.6,0.4,2.1,1l15.3,20.4c0.6,0.8,0.7,1.8,0.3,2.7c-0.4,0.9-1.3,1.4-2.3,1.4H31c0.5,19.4,11.2,24.4,11.6,24.6 c0.6,0.3,1,1,0.8,1.7C43.3,68,42.7,68.5,42,68.5z M8.2,38.1H17c0.8,0,1.4,0.6,1.5,1.4c0.4,8.8,3.3,23,18.4,25.6 C33,61.4,28,53.8,28,39.6c0-0.8,0.7-1.5,1.5-1.5h8.1L22.9,18.7L8.2,38.1z M37.9,38.7L37.9,38.7L37.9,38.7z"
}));
const Update = createSvg({
  name: 'update',
  path: UpdateGlyph
});

export default Update;
export { UpdateGlyph };
